module.exports = __webpack_public_path__ + "img/task-2.ff5d66d4.png";